// extracted by mini-css-extract-plugin
export default {"arrow":"Floater_arrow--z50"};